import http from "../../utils/http"

/**
 * 获取分页列表
 */
export function purchasePage(params) {
    return http({
        url: "/api/purchase/page",
        data: params
    })
}
/**
 * 获取详情
 */
export function purchaseDetail(params) {
    return http({
        url: "/api/purchase/info",
        data: params
    })
}
/**
 * 获取列表
 */
 export function purchaseList(params) {
    return http({
        url: "/api/purchase/list",
        data: params
    })
}
/**
 * 我的求购
 */
 export function myPurchase(params) {
    return http({
        url: "/api/purchase/myPage",
        data: params
    })
}
/**
 * 获取报价列表
 */
 export function quotationList(params) {
    return http({
        url: "/api/purchase/quotationList",
        data: params
    })
}
/**
 * 上下架求购
 */
 export function editIsshow(params) {
    return http({
        url: "/api/purchase/editIsshow",
        data: params
    })
}

/**
 * 添加
 */
 export function addPurchase(params) {
    return http({
        url: "/api/purchase/add",
        data: params
    })
}

/**
 * 编辑
 */
 export function editPurchase(params) {
    return http({
        url: "/api/purchase/edit",
        data: params
    })
}
